import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    emailSendMessage:""
}

export const helpCenterSlice = createSlice({
  name: 'helpCenter',
  initialState,
  reducers: {
    setEmailSendMessage: (state, action) => {
      state.emailSendMessage = action.payload;
    }
  },
})

// Action creators are generated for each case reducer function
export const { setEmailSendMessage } = helpCenterSlice.actions

export default helpCenterSlice.reducer